import axios from './axios'

function sendPasswordResetRequest(email) {
    return (
        axios({
            method: 'POST',
            url: 'auth-reset/users/reset_password/',
            data: {
                email: email
            }
        })
        .then(response =>  response)
        .catch((error) => {
            console.error("# ---- Reset password request sending error ---- #", error);
            throw error;
        })
    )
}

export default {
    sendPasswordResetRequest,
}